import { gql } from "@apollo/client"
import { JOB_FIELDS } from "../../jobs/fragments/jobFieldsFragment"
import { KNOWLEDGE_FIELDS } from "../../knowledge"

const POST_FIELDS = gql`
  fragment PostFields on Post {
    id
    title
    content
    hasConfirm
    hasSentConfirms
    hasComments
    visibleFrom
    mediaUrl
    mediaUpload {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    locations {
      id
      name
    }
    users {
      id
      fullName
    }
    groups {
      id
      name
    }
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    job {
      ...JobFields
    }
    knowledge {
      ...KnowledgeFields
    }
    confirmedCount
    unconfirmedCount
    currentUserNotification {
      id
      confirmed
    }
    author {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
    }
    comments {
      id
      content
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      author {
        id
        firstName
        lastName
        avatar {
          key
        }
      }
      createdAt
      reactionSummaries {
        emoji
        count
        subsetUsers
        userHasReacted
      }
    }
    reactionSummaries {
      emoji
      count
      subsetUsers
      userHasReacted
    }
    createdAt
    updatedAt
  }
  ${JOB_FIELDS}
  ${KNOWLEDGE_FIELDS}
`

const POST_FIELDS_SUMMARY = gql`
  fragment PostFieldsSummary on Post {
    id
    title
    content
    visibleFrom
    author {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
    }
    locations {
      id
      name
    }
    users {
      id
      fullName
    }
    groups {
      id
      name
    }
    createdAt
    updatedAt
  }
  ${JOB_FIELDS}
  ${KNOWLEDGE_FIELDS}
`

export { POST_FIELDS, POST_FIELDS_SUMMARY }
